import { render, staticRenderFns } from "./createOrdersView.vue?vue&type=template&id=48c6ef38&scoped=true"
import script from "./createOrdersView.vue?vue&type=script&lang=js"
export * from "./createOrdersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c6ef38",
  null
  
)

export default component.exports